const state = {
  apis: {
    one: {
      code: "",
      token: ""
    },
    internal: {
      code: "",
      token: ""
    }
  }
};
const mutations = {
  SET_AUTH(state, payload) {
    state.apis[payload.api][payload.type] = payload.value;
  }
};

const actions = {
  //todo: call other actions from authenticate, using async/await
  //... just so it can treat all eventual errors
  async authenticate({
    dispatch
  }, opt) {
    await dispatch("getCode", {
        data: {},
        api: opt.api
      })
      .then

    ();
  },

  async getCode({
    commit,
    dispatch
  }, opt) {


    /* eslint-disable */

    // Vue.log("autheticate api: ");
    /* eslint-enable */


    // print("autheticate api: " + opt.api);
    await dispatch(
      "caller/fetchData", {
        data: {
          client_id: process.env.VUE_APP_API_CLIENT_ID ,
          redirect_url: process.env.VUE_APP_API_REDIRECT_URL, 
          approval_prompt: false,
          uid: "1" //only on internal?
        },
        method: "post",
        url: process.env.VUE_APP_API_AUTHENDPOINT, 
        api: opt.api
      }, {
        root: true
      }
    ).then(async function (promise) {
      
      let payload = new Object();
      payload.api = opt.api;
      payload.type = "code";
      payload.value = promise.Result.code;

      commit("SET_AUTH", payload);
      await dispatch("getTokenWithCode", {
        data: {},
        api: opt.api
      });
    });
  },

  //always manually call "WithApp", if it fails it'll call "WithCode" by itself
  async getTokenWithApp({
    commit,
    dispatch
  }, opt) {
    await dispatch(
        "caller/fetchData", {
          data: {
            pApp: "onewebapp"
          },
          url: process.env.VUE_APP_API_GETTOKEN,
          method: "post",
          api: opt.api
        }, {
          root: true
        }
      )
      .then(async function (promise) {
        if (promise.Result.token.access_token) {
          let payload = new Object();
          payload.api = opt.api;
          payload.type = "token";
          payload.value = promise.Result.token.access_token;

          commit("SET_AUTH", payload);
        } else {
          
          await dispatch("authenticate", {
            data: {},
            api: opt.api
          }).then();
        }
      })
      .catch(async function () {
        await dispatch("getCode", {
          data: {},
          api: opt.api
        });
      });
  },
  async getTokenWithCode({
    commit,
    dispatch
  }, opt) {
    
    let params = new URLSearchParams();
    params.append("grant_type", "password");
    params.append(
      "client_id",
      process.env.VUE_APP_API_CLIENT_ID
    );
    params.append("client_secret", process.env.VUE_APP_API_CLIENT_SECRET);
    params.append("code", state.apis[opt.api]["code"]);
    params.append("uid", "1"); //one should be 0 (no diff?), internal is 1
    params.append("app", "onewebapp"); //one

    await dispatch(
        "caller/fetchData", {
          data: params,
          api: opt.api,
          url: process.env.VUE_APP_API_OAUTHENDPOINT,
          method: "post"
        }, {
          root: true
        }
      )
      .then(promise => {
        //TODO: maybe a countdown on the client side with the timeout from the promise?
        //... then get a new token before it's requested
        let payload = new Object();
        payload.api = opt.api;
        payload.type = "token";
        payload.value = promise.access_token;
        commit("SET_AUTH", payload);
      })
      .catch(function () {
        dispatch("getCode", {
          api: opt.api
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};